<div
  *ngIf="showBody"
  [ngClass]="{
    'ph--8': true,
    'pb--8': true
  }"
  [ngStyle]="{
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: '6rem'
  }"
  min-content-width
>
  <div *ngIf="showSidebar" style="min-width: 300px; grid-column: 1" class="mt--8">
    <ng-content select="ta-sidebar"></ng-content>
  </div>

  <div
    content-width
    min-body-height
    [ngClass]="{
			'bg--light': !bodyRef.transparent,
			'border--all': !bodyRef.transparent,
			'br--default': true,
			'pb--6': true,
			'w--100': true,
			'mt--8': true
		}"
    style="grid-column: 2"
  >
    <ng-container *ngIf="headerRef != null">
      <ng-container [ngTemplateOutlet]="headerRef.template"></ng-container>
    </ng-container>
    <ng-container [ngTemplateOutlet]="bodyRef.template"></ng-container>
  </div>
</div>
